import React, { Fragment } from 'react'

import {
  CheckDescription,
  DispatcherInputCheckIn,
  DispatchValidation,
  WorkOrderInput
} from '../../components/CheckDispatch/screens'
import { ConfirmMobile } from '../../components/ConfirmMobile/ConfirmMobile'
import { SwitchCheckDispatch } from '../../components/CheckDispatch/SwitchCheckDispatch/SwitchCheckDispatch'
import { useUser } from '../../hooks/useUser'
import { useCheck } from './context/useCheck'
import { checkActions } from './actions/checkActions'
import { checkBusiness } from './actions/checkBusiness'

import { Loading } from '../UI'
/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: Se crea archivo CheckWrapper por cambio a useReducer + Context
 */
export const CheckWrapper = () => {
  const {
    userDataState: { userData }
  } = useUser()

  const {
    state: {
      error,
      showCheckInDescription,
      showCheckOutDescription,
      showModal,
      workOrderSearchCheckInOut,
      checkInWorkOrder,
      workOrderDispatcher,
      wasRegistered,
      driver,
      loading
    },
    dispatch
  } = useCheck()

  const {
    setShowCheckInDescription,
    setShowCheckOutDescription,
    setShowModal
  } = checkActions()

  const { resetState, createCheckout } = checkBusiness()

  React.useEffect(() => {
    if (showCheckInDescription) {
      setTimeout(() => {
        dispatch(setShowCheckInDescription(false))
        resetState()
      }, 3000)
    }
  }, [showCheckInDescription])

  React.useEffect(() => {
    if (showCheckOutDescription) {
      setTimeout(() => {
        dispatch(setShowCheckOutDescription(false))
        resetState()
      }, 3000)
    }
  }, [showCheckOutDescription])

  if (showCheckInDescription) {
    return (
      <CheckDescription
        workOrderSearchCheckInOut={workOrderSearchCheckInOut}
        checkInWorkOrder={checkInWorkOrder}
      />
    )
  } else if (showCheckOutDescription) {
    return (
      <CheckDescription
        workOrderSearchCheckInOut={workOrderSearchCheckInOut}
        checkInWorkOrder={checkInWorkOrder}
      />
    )
  }

  const body = {
    workOrderId: workOrderSearchCheckInOut?.workOrderId!,
    carrierCode: workOrderDispatcher,
    updateCarrier: true,
    userId: userData?.userId!
  }

  return (
    <Fragment>
      <WorkOrderInput />

      <SwitchCheckDispatch />

      {loading ? (
        <Loading />
      ) : !error && !workOrderSearchCheckInOut ? (
        <Fragment>
          <DispatchValidation text='' isSuccess />
        </Fragment>
      ) : !error &&
        !wasRegistered &&
        workOrderSearchCheckInOut?.workOrderOutbound === null ? (
        <Fragment>
          <DispatchValidation
            text='OT disponible para ser asignada a transportista'
            isSuccess
          />
          <DispatcherInputCheckIn />
        </Fragment>
      ) : !error &&
        wasRegistered &&
        workOrderSearchCheckInOut?.workOrderOutbound !== null ? (
        <Fragment>
          <DispatchValidation
            text={`Puede registrar salida de transportista: ${driver}`}
            isSuccess
          />
          <DispatcherInputCheckIn />
        </Fragment>
      ) : (
        <DispatchValidation
          text={error || 'Hubo un error al registrar salida'}
          isSuccess={false}
        />
      )}

      <ConfirmMobile
        open={showModal}
        handleClose={() => dispatch(setShowModal(false))}
        onClick={() => createCheckout(body)}
        confirmHeaderText={'¡Advertencia!'}
        confirmTitle={
          'Se registrará el CheckOut para un Transportista distinto al que hizo el CheckIn'
        }
        confirmText={'Confirmar'}
        negateText={'Cancelar'}
      />
    </Fragment>
  )
}
